<script>
  import { VBTooltip } from 'bootstrap-vue';
  import dayjs from '../../core/dayjs';

  export default {
    directives: {
      'b-tooltip': VBTooltip,
    },

    props: {
      user: {
        type: Object,
        required: false,
        default: null,
      },

      message: {
        type: String,
        required: true,
      },

      created_at: {
        type: String,
        required: true,
      },

      icon: {
        type: String,
        required: false,
        default: '',
      },
    },

    computed: {
      ago () {
        return dayjs(this.created_at).fromNow();
      },

      date () {
        return dayjs(this.created_at).format('LDT');
      },
    },
  };
</script>

<template>
  <div
    class="timeline-entry-inner"
  >
    <div
      class="timeline-icon"
    >
      <i
        :class="icon || 'fa fa-asterisk'"
      />
    </div>

    <div
      class="timeline-label"
    >
      <div
        class="message"
        v-html="message"
      />

      <div
        class="time"
        v-b-tooltip.bottom="date"
      >
        <span
          class="icon mr-1"
        >
          <i
            class="fa fa-clock-o"
          />
        </span>

        {{ ago }}
      </div>

      <div
        v-if="user"
      >
        <span
          class="icon mr-1"
        >
          <i
            class="fa fa-user-o"
          />
        </span>

        {{ user.name }}
      </div>
    </div>
  </div>
</template>
